import { NgModule } from '@angular/core'
import { CmsConfig, I18nConfig, provideConfig } from '@spartacus/core'
import {
  orderTranslationChunksConfig,
  orderTranslationsDe,
  orderTranslationsEn,
  orderTranslationsJa,
  orderTranslationsZh
} from '@spartacus/order/assets'
import { ORDER_CMS_COMPONENTS, ORDER_FEATURE, OrderRootModule } from '@spartacus/order/root'

@NgModule({
  imports: [OrderRootModule],
  declarations: [],
  providers: [
    provideConfig({
      featureModules: {
        [ORDER_FEATURE]: {
          cmsComponents: [
            ...ORDER_CMS_COMPONENTS,
            'OrderDetailOverviewComponent',
            'OrderDetailItemsComponent',
            'OrderDetailTotalsComponent',
            'OrderDetailDocumentsComponent'
          ],
          module: () => import('./eb-order.module').then(m => m.EbOrderModule)
        }
      }
    } as CmsConfig),
    provideConfig({
      i18n: {
        resources: {
          en: orderTranslationsEn,
          ja: orderTranslationsJa,
          de: orderTranslationsDe,
          zh: orderTranslationsZh
        },
        chunks: orderTranslationChunksConfig
      }
    } as I18nConfig)
  ]
})
export class EbOrderFeatureModule {}
